import React from 'react'
import type { GroupHeadingProps } from 'react-select'
import { components } from 'react-select'

import { GroupHeadingStyled } from './GroupHeading.styles'

const GroupHeading = (props: GroupHeadingProps) => (
  <GroupHeadingStyled>
    <components.GroupHeading {...props} />
  </GroupHeadingStyled>
)

export default GroupHeading
